module.exports = __webpack_public_path__ + "img/ew-icon_trainer.cbf48b02.svg";